import { Constant } from '../helpers/const';
import HttpService from './HttpService';

class AuthService {
    login(username, password, recaptcha) {
        return new HttpService().getJsonRequest()
            .post("/v1/auth/signin", {username, password, recaptcha});
    }

    logout() {
        localStorage.removeItem(Constant.ACCOUNT);
        localStorage.removeItem(Constant.USER_PROFILE);
    }

    register(username, email, password) {
        return new HttpService().getJsonRequest()
            .post("/v1/auth/signup", {
                username,
                email,
                password,
            });
    }

    setLocale(locale) {
        return new HttpService().getAuthTokenRequest()
            .post("/v1/auth/locale/change", {locale});
    }

    getProfile() {
        return new HttpService().getAuthTokenRequest().get("/v1/users/profile");
    }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new AuthService();
